/**
 * Centered toast shown while AI designs are being saved from the dashboard.
 */
import React from 'react';
import { FloppyDiskIcon } from '@phosphor-icons/react';
import type { DashboardSavingProgressToastProps } from './DashboardSavingProgressToast.types';
import '../oneButton-css/DashboardSavingProgressToast.css';

export const DashboardSavingProgressToast: React.FC<DashboardSavingProgressToastProps> = ({
    theme,
    visible,
    progress,
}) => {
    if (!visible) return null;

    const clampedProgress = Math.min(100, Math.max(0, Math.round(progress)));

    return (
        <div
            className={`editor-ai-saving-toast obd-theme-${theme}`}
            role="status"
            aria-live="polite"
            aria-label={`Saving designs, ${clampedProgress} percent complete`}
        >
            <div className="editor-ai-saving-toast__icon" aria-hidden>
                <FloppyDiskIcon size={18} weight="fill" />
            </div>
            <div className="editor-ai-saving-toast__body">
                <div className="editor-ai-saving-toast__row">
                    <span className="editor-ai-saving-toast__label">Saving designs…</span>
                    <span className="editor-ai-saving-toast__percent">{clampedProgress}%</span>
                </div>
                <div className="editor-ai-saving-toast__bar" aria-hidden>
                    <div
                        className="editor-ai-saving-toast__bar-fill"
                        style={{ width: `${clampedProgress}%` }}
                    />
                </div>
            </div>
        </div>
    );
};
